import React from 'react'
import useDebounce from 'react-use/lib/useDebounce'
import useWindowScroll from 'react-use/lib/useWindowScroll'

export default function useScrollPercent(
  ref: React.RefObject<HTMLElement>,
  scrollPercent: number,
  classList: string[]
): void {
  const { y: windowY } = useWindowScroll()

  const handleScroll = () => {
    const hasScrolledEnough =
      windowY > document.body.scrollHeight * scrollPercent

    if (ref.current) {
      if (hasScrolledEnough) {
        ref.current.classList.add(...classList)
      } else {
        ref.current.classList.remove(...classList)
      }
    }
  }

  useDebounce(() => handleScroll(), 5, [windowY])
}
